import { render } from "./FeedbackDialog.vue?vue&type=template&id=65e44776&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=65e44776&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e44776"]])

export default __exports__